import HoldingStatus from 'src/app/shared/enums/HoldingStatus.enum';

export class UpdateHoldingStatusResult {
  constructor(
    public status: HoldingStatus,
    public openPartialEdit: boolean = false,
    public draftSendEmailsWhenMovingToUnderManagement: boolean = false) {
  }
}
